import React, { useEffect, useState } from 'react';
import { EmailVerificationForm } from '../../components/forms';

const EmailVerificationPage: React.FC = () => {
  const [userEmail, setUserEmail] = useState<string>('');

  useEffect(() => {
    if (localStorage.getItem('user-email')) {
      setUserEmail(localStorage.getItem('user-email') || '');
    }
  }, []);

  return (
    <div className='h-full flex flex-col justify-center w-full max-w-[27.5rem] mx-auto py-12'>
      <h2 className='!text-4xl !font-medium mb-1 text-secondary-500 lg:text-left text-center'>
        Email verification
      </h2>
      <p className='text-sm mb-6 lg:text-left text-center'>
        Check your inbox - we’ve sent a code to{' '}
        <span className='text-theme-blue-700'>{userEmail}</span>
      </p>

      <EmailVerificationForm />
    </div>
  );
};

export default EmailVerificationPage;
